import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button, Card, CardBody, Col, Container, Row, Form, FormFeedback, Label, Input, Spinner } from 'reactstrap';
import ParticlesAuth from "../ParticlesAuth";
//import images
import logoLight from "../../../assets/images/KoottuWhite.png";
import avatar1 from "../../../assets/images/users/avatar-1.jpg";
import { useNavigate } from 'react-router-dom';
import { useFormik } from "formik";
import * as Yup from "yup";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import config from '../../../config';

const BasicLockScreen = () => {
    document.title = "Lock Screen | Koottu Admin";
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [user, setUser] = useState(null);
    const sessionData = JSON.parse(sessionStorage.getItem("sessionData"));

    useEffect(() => {
        // Get user data from session storage
        const authUser = JSON.parse(sessionStorage.getItem("authUser"));
        if (!authUser) {
            navigate('/login');
            return;
        }
        setUser(authUser);
    }, [navigate]);

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            password: '',
        },
        validationSchema: Yup.object({
            password: Yup.string()
                .min(4, 'Password must be at least 4 characters')
                .required('Please Enter Your Password'),
        }),
        onSubmit: async (values) => {
            try {
                setLoading(true);
                console.log('This Config:', config); // Debug log

                const loginPayload = {
                    data: [{
                        email: sessionData.email,
                        password: values.password,
                        appName: config.appName
                    }]
                };

                const response = await fetch(`${config.api.API_URL}python/login/`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(loginPayload)
                });

                const data = await response.json();

                if (response.ok && data.result) {
                    // Update session storage with new token
                    
                    sessionStorage.setItem("authUser", JSON.stringify(data.result[0]));
                    
                    toast.success('Unlocked successfully!', {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        theme: "colored"
                    });
                    navigate('/dashboard');
                } else {
                    throw new Error(data.message || 'Invalid credentials');
                }
            } catch (error) {
                toast.error(error.message || 'Failed to unlock', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    theme: "colored"
                });
            } finally {
                setLoading(false);
            }
        }
    });

    if (!user) {
        return null; // or a loading spinner
    }

    return (
        <React.Fragment>
            <div className="auth-page-content">
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="colored"
                />
                <div className="auth-page-wrapper">
                    <ParticlesAuth>
                        <div className="auth-page-content">
                            <Container>
                                <Row>
                                    <Col lg={12}>
                                        <div className="text-center mt-sm-5 mb-4 text-white-50">
                                            <div>
                                                <Link to="/" className="d-inline-block auth-logo">
                                                    <img src={logoLight} alt="" height="80" />
                                                </Link>
                                            </div>
                                            <p className="mt-3 fw-medium auth-tagline" style={{ fontSize: "25px", fontFamily: "'Merriweather', serif" }}>
                                                <s>Matrimonial</s>. <s>Dating</s>. Koottu.
                                            </p>
                                        </div>
                                    </Col>
                                </Row>

                                <Row className="justify-content-center">
                                    <Col md={8} lg={6} xl={5}>
                                        <Card className="mt-4">
                                            <CardBody className="p-4">
                                                <div className="text-center mt-2">
                                                    <h5 className="text-primary">Lock Screen</h5>
                                                    <p className="text-muted">Enter your password to unlock the screen!</p>
                                                </div>
                                                <div className="user-thumb text-center">
                                                    <img src={avatar1} className="rounded-circle img-thumbnail avatar-lg" alt="thumbnail" />
                                                    <h5 className="font-size-15 mt-3">{user.username}</h5>
                                                </div>
                                                <div className="p-2 mt-4">
                                                    <Form
                                                        onSubmit={(e) => {
                                                            e.preventDefault();
                                                            validation.handleSubmit();
                                                            return false;
                                                        }}
                                                    >
                                                        <div className="mb-3">
                                                            <Label className="form-label" htmlFor="password-input">Password</Label>
                                                            <Input
                                                                name="password"
                                                                type="password"
                                                                className="form-control"
                                                                id="password-input"
                                                                placeholder="Enter password"
                                                                value={validation.values.password}
                                                                onBlur={validation.handleBlur}
                                                                onChange={validation.handleChange}
                                                                invalid={validation.touched.password && validation.errors.password}
                                                            />
                                                            {validation.touched.password && validation.errors.password && (
                                                                <FormFeedback type="invalid">{validation.errors.password}</FormFeedback>
                                                            )}
                                                        </div>
                                                        <div className="mb-2 mt-4">
                                                            <Button 
                                                                color="success" 
                                                                className="w-100" 
                                                                type="submit"
                                                                disabled={loading}
                                                            >
                                                                {loading ? <Spinner size="sm" className='me-2'> Loading... </Spinner> : null}
                                                                Unlock
                                                            </Button>
                                                        </div>
                                                    </Form>
                                                </div>
                                            </CardBody>
                                        </Card>
                                        <div className="mt-4 text-center">
                                            <p className="mb-0">Not you ? return <Link to="/login" className="fw-semibold text-primary text-decoration-underline"> Signin </Link> </p>
                                        </div>
                                    </Col>
                                </Row>
                            </Container>
                        </div>
                    </ParticlesAuth>
                </div>
            </div>
        </React.Fragment>
    );
};

export default BasicLockScreen;